import bankCodes from '@/languages/ko-kr/bank-codes'
import enablingStatus from '@/languages/ko-kr/enabling-status'

export default {
  'cert-center': '@:pages.setting.cert-center',
  'certificate': '@:terms.certificate',
  'cert': '인증서',
  'bank': '@:terms.bank',
  'register-cert': '@:pages.cert-center.cert @:terms.register하기',
  're-register': '재@:terms.enabling 시도하기',
  'cancel': '@:terms.cancel',
  'expiry-date': '@:terms.expired일자',
  'corporate': '@:terms.corporate@:terms.business-operator | ' +
    '@:terms.individual@:terms.business-operator',
  'will-expired': '오늘 @:terms.expired됩니다. | 내일 @:terms.expired됩니다. | ' +
    '{days}@:terms.days @:terms.after @:terms.expired됩니다.',
  'select-bank-codes': ['연결할', '@:terms.bank을 선택해주세요'],
  'institution': {
    'giro': '@:terms.giro',
    'hometax': '@:terms.hometax',
    'bank': '@:terms.bank',
    ...bankCodes,
  },
  'status': {
    ...enablingStatus,
  },
  'message': {
    'search-banks': '이용중인 @:terms.bank이 목록에 없나요?',
  },
  'failed-reason': {
    'title': '@:terms.enabling 실패사유',
    'empty': ['실패사유 목록이 없습니다.'],
  },
  'error': {
    'get-institutions': '@:terms.enabling된 기관 목록을 불러오는데 실패하였습니다.',
    'get-failed-reason': '@:terms.enabling된 기관의 실패사유를 불러오는데 실패하였습니다.',
    'update-institution': '@:terms.enabling 기관 정보를 수정하는데 실패하였습니다.',
  },
  'add-type': {
    'cert': '등록한 @:terms.certificate로 @:terms.enabling하기',
    'add': '새로운 @:terms.certificate @:terms.register하기',
  }
}
